import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData } from '@/auth/utils'
import pages from './routes/pages'
import user from './routes/menu/user'
import food from './routes/menu/food'
import diet from './routes/menu/diet'
import activity from './routes/menu/activity'
import others from './routes/menu/others'
import order from './routes/menu/order'
import ticket from './routes/menu/ticket'
import banner from './routes/menu/banner'
import notification from './routes/menu/notification'
import declaration from './routes/menu/declaration'
import dashboard from './routes/menu/dashboard'
import blog from './routes/menu/blog'
import checkErrors from './routes/menu/checkErrors'
import dedicatedDiet from './routes/menu/dedicatedDiet'
import affiliate from './routes/menu/affiliate'
import hero from './routes/menu/hero'
import product from './routes/menu/product'
import campaigns from './routes/menu/campaign'
import landings from './routes/menu/landing'
import messenger from './routes/menu/messenger'
import prizeWheel from './routes/menu/prizeWheel'
import callCenter from './routes/menu/callCenter'
import messagePin from './routes/menu/messagePin'
import bills from './routes/menu/bills'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'home', redirect: { name: 'user' } },
    ...pages,
    ...user,
    ...food,
    ...others,
    ...diet,
    ...activity,
    ...order,
    ...ticket,
    ...banner,
    ...dashboard,
    ...blog,
    ...notification,
    ...checkErrors,
    ...dedicatedDiet,
    ...affiliate,
    ...hero,
    ...product,
    ...campaigns,
    ...landings,
    ...messenger,
    ...prizeWheel,
    ...callCenter,
    ...declaration,
      ...messagePin,
      ...bills,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    //   // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })
    //
    // If logged in => not authorized
    return next({ name: 'not-authorized' })
  }

  if (!isLoggedIn && to.name !== 'login') return next({ name: 'login' })

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next('/')
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
